import { Tag } from "antd";
import { useAppTranslation } from "~/hooks/useAppTranslation";
import * as APITypes from "~/API";

export const LeaseTypeTag = ({ type }: { type: APITypes.LeaseTypeOptions }) => {
  const { t } = useAppTranslation();
  let color = "blue";
  let typeText = t("Monthly");

  switch (type) {
    case APITypes.LeaseTypeOptions.ThreeYears: {
      typeText = t("3_years");
      break;
    }
    case APITypes.LeaseTypeOptions.TwoYears: {
      typeText = t("2_years");
      break;
    }
    case APITypes.LeaseTypeOptions.OneYear: {
      typeText = t("1_year");
      break;
    }
    case APITypes.LeaseTypeOptions.SixMonths: {
      typeText = t("6_months");
      break;
    }
    case APITypes.LeaseTypeOptions.ThreeMonths: {
      typeText = t("3_months");
      break;
    }
  }

  return <Tag color={color}>{typeText}</Tag>;
};
